// Lightweight native-scroll gallery for product cards.
(function () {
  'use strict';

  function makeImageEager(slide) {
    if (!slide) return;
    slide.querySelectorAll('img').forEach(function (img) {
      // Only the slide the shopper explicitly requests is promoted. Never
      // preload every photo on touchstart: vertical page scrolling also emits
      // touchstart and was causing mobile request bursts.
      // Stiletto's image snippet stores lazy URLs in data-src/data-srcset, so
      // changing only the loading attribute is not enough to start a request.
      if (img.dataset.srcset && !img.getAttribute('srcset')) {
        img.setAttribute('srcset', img.dataset.srcset);
        img.removeAttribute('data-srcset');
      }

      if (img.dataset.src && !img.getAttribute('src')) {
        img.setAttribute('src', img.dataset.src);
        img.removeAttribute('data-src');
      }

      img.loading = 'eager';
    });
  }

  function initTrack(track) {
    if (track.dataset.scrollReady) return;

    var scroller = track.closest('.product-item__scroller');
    if (!scroller) return;

    var dotsContainer = scroller.querySelector('[data-scroll-dots]');
    var dots = dotsContainer ? Array.prototype.slice.call(dotsContainer.children) : [];
    if (!dots.length) return;

    track.dataset.scrollReady = 'true';

    var slides = Array.prototype.slice.call(
      track.querySelectorAll('.product-item__scroll-slide')
    );
    var prevButton = scroller.querySelector('[data-scroll-prev]');
    var nextButton = scroller.querySelector('[data-scroll-next]');
    var ticking = false;

    function currentIndex() {
      var slideWidth = track.clientWidth || 1;
      return Math.max(0, Math.min(Math.round(track.scrollLeft / slideWidth), dots.length - 1));
    }

    function updateState(promoteCurrentImage) {
      var index = currentIndex();

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });

      if (prevButton) prevButton.disabled = index === 0;
      if (nextButton) nextButton.disabled = index === dots.length - 1;

      // A native horizontal swipe may not use the arrow buttons. Promote only
      // the slide that actually became current, and never do this during the
      // initial scan (which would eagerly load the first image of every card).
      if (promoteCurrentImage) makeImageEager(slides[index]);
      ticking = false;
    }

    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateState(true);
        });
      },
      { passive: true }
    );

    if (prevButton) {
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        var targetIndex = Math.max(0, currentIndex() - 1);
        makeImageEager(slides[targetIndex]);
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        var targetIndex = Math.min(slides.length - 1, currentIndex() + 1);
        makeImageEager(slides[targetIndex]);
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
    }

    updateState(false);
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-scroll-track]').forEach(initTrack);
  }

  function start() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('[data-scroll-track]')) {
            initTrack(node);
          }

          scan(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
